/**
 * oatful-market-behavior.js
 *
 * Two small, market-based page behaviors, kept in one file since both key
 * off the same URL-based market detection:
 *
 * 1. CURRENCY DISPLAY — shows prices in the visitor's local GCC currency
 *    based on their Shopify Markets URL (e.g. /en-sa/, /ar-qa/). Only
 *    rewrites price TEXT already on the page — checkout always stays in
 *    AED, nothing here touches cart or product price data.
 *
 * 2. READY-TO-EAT VISIBILITY — the Ready-to-Eat collection section (and
 *    its matching pill button in the sticky shop nav bar) is shown for
 *    UAE visitors only, hidden everywhere else — it's a refrigerated
 *    product that doesn't ship internationally. The section's numbered
 *    badge (01, 02, 03...) is a CSS counter that automatically skips
 *    display:none sections, so hiding this one never leaves a gap in the
 *    numbering — see oatful-shop-collection.liquid.
 */
(function () {
  'use strict';

  // Shopify Markets already puts visitors on a country-specific URL
  // (e.g. /en-sa/products/..., /ar-qa/...) — that alone is reliable enough
  // to detect the market, no extra fallback logic needed.
  var path = window.location.pathname.toLowerCase();
  var FX = {
    sa: { rate: 1.02,  code: 'SAR' },
    qa: { rate: 0.99,  code: 'QAR' },
    om: { rate: 0.10,  code: 'OMR' },
    kw: { rate: 0.081, code: 'KWD' }
  };

  var market = null;
  Object.keys(FX).forEach(function (c) {
    if (path.indexOf('/' + c + '/') === 0 || path.indexOf('/en-' + c) === 0 || path.indexOf('/ar-' + c) === 0) {
      market = c;
    }
  });

  var isUAE = !market; // no GCC market prefix matched — default is UAE

  /* ── 1. Ready-to-Eat visibility (UAE only — cold-chain product, not
     shipped internationally, so this is hidden for every GCC market
     except UAE, the reverse of what a first pass at this had) ────────── */
  if (!isUAE) {
    var style = document.createElement('style');
    style.textContent = '#ready-to-eat, .oat-chip[data-target="ready-to-eat"] { display: none !important; }';
    (document.head || document.documentElement).appendChild(style);
  }

  /* ── 2. Currency display (GCC markets only) ────────────────────────── */
  if (isUAE) return; // UAE keeps AED/Dhs prices as-is, nothing left to do

  var rate = FX[market].rate;
  var code = FX[market].code;

  // Every price display element across the theme (PDP, product cards on
  // shop/collection pages, sticky bars, bundle builders, upsells).
  var SELECTOR = [
    '.oa-pdp__price', '#oa-price',
    '.oat-card__price', '.oat-card__compare', '.oat-card__save',
    '.oa-sticky-atc__price', '#oa-sticky-price',
    '.oa-mobile-sticky__price', '#oa-mobile-sticky-price',
    '.oa-pdp-upsell__price',
    '.oa-bb__sum-price', '.oa-bb__ms-price',
    '.oa-sb__sum-price', '.oa-sb__ms-price',
    '.oa-starter__price'
  ].join(', ');

  // Matches either price format the theme uses ("Dhs. 89.50" or "AED 89.50")
  // and replaces only that portion — so text like "Save Dhs. 20.00" becomes
  // "Save SAR 20" instead of losing the word "Save" entirely.
  var PRICE_RE = /(?:Dhs\.|AED)\s*([\d,]+\.?\d*)/;

  function convert(el) {
    if (!el) return;
    var text = el.textContent;
    if (el.dataset.oaConverted === text) return; // already converted this exact text
    var match = text.match(PRICE_RE);
    if (!match) return;
    var aed = parseFloat(match[1].replace(/,/g, ''));
    if (isNaN(aed)) return;
    var newText = text.replace(PRICE_RE, code + ' ' + Math.ceil(aed * rate));
    el.dataset.oaConverted = newText;
    el.textContent = newText;
  }

  function convertAll() {
    document.querySelectorAll(SELECTOR).forEach(convert);
  }

  convertAll();

  // Re-convert automatically when a price element's text changes — e.g.
  // switching subscription frequency or selecting a different variant,
  // both of which rewrite these same elements after this script's first
  // pass. Scoped only to the price elements themselves, not the whole
  // page, so this stays cheap.
  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (m) {
      convert(m.target.nodeType === 3 ? m.target.parentElement : m.target);
    });
  });
  document.querySelectorAll(SELECTOR).forEach(function (el) {
    observer.observe(el, { childList: true, characterData: true, subtree: true });
  });

  // Product-grid cards (shop/collection pages) can render in after initial
  // load — watch for newly-added cards and convert those too, without
  // re-scanning the whole document on every unrelated DOM change.
  var bodyObserver = new MutationObserver(function (mutations) {
    var found = false;
    mutations.forEach(function (m) {
      m.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;
        if ((node.matches && node.matches('.oat-card')) || (node.querySelector && node.querySelector('.oat-card'))) {
          found = true;
        }
      });
    });
    if (found) convertAll();
  });
  bodyObserver.observe(document.body, { childList: true, subtree: true });
})();